import SocketTester from 'components/SocketTester';

const SocketTesterContainer = () => {
  return <SocketTester />;
};

export default SocketTesterContainer;
